import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  FormControlLabel,
  Switch,
  Grid
} from '@material-ui/core';
import { Search as SearchIcon, RefreshCw as RefreshIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AfiliadosListToolbar = ({
  search,
  setSearch,
  showPendingOnly,
  setShowPendingOnly,
  onRefresh,
  ...rest
}) => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  return (
    <Box {...rest}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          {!auth.user?.is_admin && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => navigate('/app/afiliado')}
            >
              Cadastrar Novo Canal
            </Button>
          )}
          <Button
            color="secondary"
            variant="outlined"
            onClick={onRefresh}
            startIcon={<RefreshIcon />}
          >
            Atualizar
          </Button>
        </Box>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )
                  }}
                  placeholder="Pesquisar canal..."
                  variant="outlined"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Grid>
              {auth.user?.is_admin && (
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={showPendingOnly}
                        onChange={(e) => setShowPendingOnly(e.target.checked)}
                        name="showPendingOnly"
                        color="primary"
                      />
                    }
                    label="Mostrar apenas pendentes"
                  />
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

AfiliadosListToolbar.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  showPendingOnly: PropTypes.bool,
  setShowPendingOnly: PropTypes.func,
  onRefresh: PropTypes.func
};

export default AfiliadosListToolbar;
